module.exports = __webpack_public_path__ + "static/media/ZJ1.963c2184.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/ZJ1.png
// module id = 939
// module chunks = 0